require(
  [
    'reviewsRedesignInitializer',
  ]
);

define("nhs/views/BuilderShowCaseRedesign/ShowReviews", function(){});

